import { Download, Edit } from '@mui/icons-material';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { DownloadTemplatePayload, ReportTemplate, TemplateType } from '../store/types';

interface Props {
  row: ReportTemplate;
  templateType: TemplateType;
  onEdit: (row: ReportTemplate, type: TemplateType) => void;
  onDownload: (payload: DownloadTemplatePayload) => void;
}

const normaliseId = (id?: string | null) => (id && id.trim().length > 0 ? id : null);

export const ReportTemplateCell = ({ row, templateType, onEdit, onDownload }: Props): JSX.Element => {
  const isWord = templateType === 'Word';
  const rawId = isWord ? row.wordTemplateId : row.excelTemplateId;
  const id = normaliseId(rawId);
  const hasTemplate = !!id;

  return (
    <Box display="flex" alignItems="center" gap={1}>
      {hasTemplate && (
        <Typography variant="body2" noWrap title={id ?? undefined}>
          {id}
        </Typography>
      )}

      {hasTemplate && (
        <Tooltip title={`Download ${templateType} template`}>
          <IconButton
            size="small"
            color="primary"
            onClick={(e) => {
              e.stopPropagation();
              onDownload({
                id: row.id,
                name: row.name,
                templateFormat: templateType,
              });
            }}
          >
            <Download fontSize="small" />
          </IconButton>
        </Tooltip>
      )}

      <Tooltip title={`Upload / Update ${templateType} template`}>
        <IconButton
          size="small"
          color="primary"
          onClick={(e) => {
            e.stopPropagation();
            onEdit(row, templateType);
          }}
        >
          <Edit fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};
